<div class="auth-page">
  <div class="auth-card">
    <!-- Header -->
    <div class="auth-head">
      <nubo-logo variant="lockup" size="lg" class="auth-logo"></nubo-logo>
      <h1>Create your account</h1>
      <p class="auth-sub">Set up your Nubo workspace in a minute.</p>
    </div>

    <!-- Error -->
    <div class="auth-error" *ngIf="errorMessage" role="alert">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <!-- Form -->
    <!-- Registration closed -->
    <div *ngIf="registrationOpen === false" class="auth-success auth-closed">
      <div class="success-icon"><mat-icon>lock_clock</mat-icon></div>
      <h2>Registration is currently closed</h2>
      <p>We’re not accepting new sign-ups right now. Please check back soon.<br />Already have an account? You can still sign in.</p>
      <button type="button" class="auth-btn" (click)="goToLogin()">
        <mat-icon>login</mat-icon><span>Go to sign in</span>
      </button>
    </div>

    <form *ngIf="registrationOpen && !registrationSuccess" [formGroup]="registrationForm" (ngSubmit)="onSubmit()" class="auth-form" novalidate>
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>First name</mat-label>
          <input matInput formControlName="firstName" autocomplete="given-name" />
          <mat-error *ngIf="registrationForm.get('firstName')?.hasError('required')">Required.</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Last name</mat-label>
          <input matInput formControlName="lastName" autocomplete="family-name" />
          <mat-error *ngIf="registrationForm.get('lastName')?.hasError('required')">Required.</mat-error>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Email address</mat-label>
        <input matInput type="email" formControlName="email" autocomplete="email" placeholder="you@company.com" />
        <mat-error *ngIf="registrationForm.get('email')?.hasError('required')">Email is required.</mat-error>
        <mat-error *ngIf="registrationForm.get('email')?.hasError('email')">Enter a valid email address.</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Phone number (optional)</mat-label>
        <input matInput formControlName="phone" autocomplete="tel" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Company name</mat-label>
        <input matInput formControlName="company" autocomplete="organization" />
        <mat-error *ngIf="registrationForm.get('company')?.hasError('required')">Company name is required.</mat-error>
      </mat-form-field>

      <button type="submit" class="auth-btn" [disabled]="loading">
        <span class="spinner" *ngIf="loading"></span>
        <ng-container *ngIf="!loading"><mat-icon>person_add</mat-icon><span>Create account</span></ng-container>
        <ng-container *ngIf="loading">Creating account…</ng-container>
      </button>
    </form>

    <!-- Success -->
    <div *ngIf="registrationSuccess" class="auth-success">
      <div class="success-icon"><mat-icon>check_circle</mat-icon></div>
      <h2>You’re all set</h2>
      <p>Your account is ready. Sign in to get started.</p>
      <button type="button" class="auth-btn" (click)="goToLogin()">
        <mat-icon>login</mat-icon><span>Go to sign in</span>
      </button>
    </div>

    <!-- Footer -->
    <div class="auth-footer" *ngIf="registrationOpen && !registrationSuccess">
      Already have an account? <a routerLink="/login">Sign in</a>
    </div>
  </div>
</div>
